import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function HighlightedCard() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <InsightsRoundedIcon />
        <Typography
          component="h2"
          variant="subtitle2"
          gutterBottom
          sx={{ fontWeight: '600' }}
        >
          Dias em aberto
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: '8px' }}>
          12
        </Typography>
        <Typography
          component="h2"
          variant="subtitle2"
          gutterBottom
          sx={{ fontWeight: '600' }}
        >
          ID do caso
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: '8px' }}>
          IDV-2732
        </Typography>
        <Button
          variant="contained"
          // size="small"
          color="success"
          fullWidth={isSmallScreen}
          onClick={() => {
            alert('clicked')
          }}
        >
          Atualizar
        </Button>
        <Button
          variant="contained"
          // size="small"
          color="error"
          fullWidth={isSmallScreen}
          onClick={() => {
            alert('closed')
          }}
        >
          Encerrar
        </Button>
      </CardContent>
    </Card>
  );
}
